export default "__VITE_PUBLIC_ASSET__bbca5bf3__"